module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/e420f1d3387b0426a7d0ce0cc831dc26.svg";